<!-- Start Page Header -->
<div class="page-header">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h2 class="entry-title">{{'team' | translate}}</h2>
                <div class="breadcrumb">
                    <span>{{'here' | translate}}: </span>
                    <a routerLink="/Home"> {{'home' | translate}}</a>
                    <span class="crumbs-spacer"><i class="fa fa-angle-double-right"></i></span>
                    <span class="current">{{'team' | translate}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page Header -->

<!-- Start Content Section -->
<div class="team section">
    <div class="container">
        <!-- Start Heading -->
        <div class="heading">
            <div class="section-title">{{'Team' | translate}} <span>{{'Members' | translate}}</span></div>
        </div>
        <!-- End Heading -->
        <!-- Some Text -->
        <p class="description text-center">
            {{'TeamDes' | translate}}
        </p>
        <div class="team-2">
            <div class="row">
                <div class="col-md-3 col-sm-6">
                    <div class="team-member">
                        <div class="team-thumbnail">
                            <img src="../../../../assets/images/team/eng-zuhair.jpg" alt="">
                            <div class="overlay">
                                <p class="text"></p>
                                <div class="info name">
                                    <h4>{{'T1' | translate}}</h4>
                                    <p>{{'T1D' | translate}}</p>
                                </div>
                                <div class="social-media">
                                    <a href="https://www.facebook.com/engzuhair68?fref=ts" class="facebook"><i
                                            class="fa fa-facebook"></i></a>

                                    <a href="https://sa.linkedin.com/in/zuhair-wanli-5515a6102/en" class="linkedin"><i
                                            class="fa fa-linkedin"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="info">
                            <h4>{{'T1' | translate}}</h4>
                            <p>{{'T1D' | translate}}</p>
                        </div>
                    </div>
                </div>
                <!-- Start Memebr 1 -->
                <div class="col-md-3 col-sm-6">
                    <div class="team-member">
                        <div class="team-thumbnail">
                            <img height="100" src="../../../../assets/images/team/Tonsy1png.png" alt="">
                            <div class="overlay">
                                <p class="text"></p>
                                <div class="info name">
                                    <h4>{{'T2' | translate}}</h4>
                                    <p>{{'T2D' | translate}}</p>
                                </div>
                                <div class="social-media">
                                    <a href="https://www.facebook.com/tunisation" class="facebook"><i
                                            class="fa fa-facebook"></i></a>
                                    <a href="https://twitter.com/#" class="twitter"><i class="fa fa-twitter"></i></a>
                                    <a href="https://plus.google.com/+tunisation" class="google"><i
                                            class="fa fa-google-plus"></i></a>
                                    <a href="https://eg.linkedin.com/in/tunisation" class="linkedin"><i
                                            class="fa fa-linkedin"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="info">
                            <h4>{{'T2' | translate}}</h4>
                            <p>{{'T2D' | translate}}</p>
                        </div>
                    </div>
                </div>
                <!-- Start Memebr 2 -->
                <div class="col-md-3 col-sm-6">
                    <div class="team-member">
                        <div class="team-thumbnail">
                            <img src="../../../../assets/images/team/Ahmed1.png" alt="">
                            <div class="overlay">
                                <p class="text"></p>
                                <div class="info name">
                                    <h4>{{'T3' | translate}}</h4>
                                    <p>{{'T3D' | translate}}</p>
                                </div>
                                <div class="social-media">
                                    <a href="https://www.facebook.com/goharyone?fref=ts" class="facebook"><i
                                            class="fa fa-facebook"></i></a>
                                    <a href="https://twitter.com/goharyone" class="twitter"><i
                                            class="fa fa-twitter"></i></a>
                                    <a href="https://plus.google.com/u/0/105524579950788841990" class="google"><i
                                            class="fa fa-google-plus"></i></a>
                                    <a href="https://eg.linkedin.com/in/ahmed-gohary-25666951" class="linkedin"><i
                                            class="fa fa-linkedin"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="info">
                            <h4>{{'T3' | translate}}</h4>
                            <p>{{'T3D' | translate}}</p>
                        </div>
                    </div>
                </div>
                <!-- Start Memebr 3 -->
                <!---->
                <!-- Start Memebr 4 -->
                <div class="col-md-3 col-sm-6">
                    <div class="team-member">
                        <div class="team-thumbnail">
                            <img src="../../../../assets/images/team/zaki.png" alt="">
                            <div class="overlay">
                                <p class="text"></p>
                                <div class="info name">
                                    <h4>{{'T4' | translate}}</h4>
                                    <p>{{'T4D' | translate}} </p>
                                </div>
                                <div class="social-media">
                                    <a href="https://www.facebook.com/zaki.eldsoque" class="facebook"><i
                                            class="fa fa-facebook"></i></a>
                                    <a href="https://twitter.com/zeko_Eldsoque" class="twitter"><i
                                            class="fa fa-twitter"></i></a>
                                    <a href="https://plus.google.com/+ZakiEldsoque" class="google"><i
                                            class="fa fa-google-plus"></i></a>
                                    <a href="https://eg.linkedin.com/in/zakieldsoque" class="linkedin"><i
                                            class="fa fa-linkedin"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="info">
                            <h4>{{'T4' | translate}}</h4>
                            <p>{{'T4D' | translate}} </p>
                        </div>
                    </div>
                </div>
                <!-- End Memebr 4 -->
                <!-- Start Memebr 5 -->
                <div class="col-md-3 col-sm-6">
                    <div class="team-member">
                        <div class="team-thumbnail">
                            <img src="../../../../assets/images/team/AlyHassan.png" alt="">
                            <div class="overlay">
                                <p class="text"></p>
                                <div class="info name">
                                    <h4>{{'T5' | translate}}</h4>
                                    <p>{{'T5D' | translate}} </p>
                                </div>
                                <div class="social-media">
                                    <a href="https://www.facebook.com/alyhassan.acc" class="facebook"><i
                                            class="fa fa-facebook"></i></a>
                                    <!--<a href="https://twitter.com/zeko_Eldsoque" class="twitter"><i class="fa fa-twitter"></i></a>-->
                                    <!--   <a href="https://plus.google.com/+ZakiEldsoque" class="google"><i class="fa fa-google-plus"></i></a>-->
                                    <a href="http://www.linkedin.com/in/alyhassan" class="linkedin"><i
                                            class="fa fa-linkedin"></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="info">
                            <h4>{{'T5' | translate}}</h4>
                            <p>{{'T5D' | translate}} </p>
                        </div>
                    </div>
                </div>
                <!-- End Memebr 5 -->
                <!-- Start Memebr 6 -->
                <div class="col-md-3 col-sm-6">
                    <div class="team-member">
                        <div class="team-thumbnail">
                            <img src="../../../../assets/images/team/hazem.png" alt="">
                            <div class="overlay">
                                <p class="text"></p>
                                <div class="info name">
                                    <h4>{{'T6' | translate}}</h4>
                                    <p>{{'T6D' | translate}} </p>
                                </div>
                                <div class="social-media">
                                    <a href="https://www.facebook.com/hazem.abdulelmordy" class="facebook"><i
                                            class="fa fa-facebook"></i></a>
                                    <!--<a href="https://twitter.com/zeko_Eldsoque" class="twitter"><i class="fa fa-twitter"></i></a>-->
                                    <!--<a href="https://plus.google.com/+ZakiEldsoque" class="google"><i class="fa fa-google-plus"></i></a>-->
                                    <!--<a href="https://eg.linkedin.com/in/zakieldsoque" class="linkedin"><i class="fa fa-linkedin"></i></a>-->
                                </div>
                            </div>
                        </div>
                        <div class="info">
                            <h4>{{'T6' | translate}}</h4>
                            <p>{{'T6D' | translate}} </p>
                        </div>
                    </div>
                </div>
                <!-- End Memebr 6 -->

            </div>
        </div>
    </div>
</div>
<!-- End Content Section  -->